import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class ProtectionService {

  constructor(private http: HttpClient) { }

  getAllProtections(): Observable<any> {
    return this.http.get(mainUrl + 'param-protections')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createProtection(form): Observable<any> {
    return this.http.post(mainUrl + 'param-protection', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getProtectionById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-protection/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateProtection(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-protection/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteProtection(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-protection/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}